import { Inline, useCollapse } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useCategoriesImport } from 'hooks'
import { LIMITS } from 'shared'
import { Item } from 'typings'
import { CategoriesSelector } from 'ui'
import { CollapsibleRule } from '../CollapsibleRule'
import { SelectorComponentProps } from '../constants'
import { OperatorSelector } from '../OperatorSelector'

export function CategoriesScopeSelector(props: SelectorComponentProps) {
  const { name, form, open } = props

  const items: Item[] = useWatch({ form, name: `${name}.items` })

  const collapsibleState = useCollapse({ visible: open })

  const { importCategories, loading } = useCategoriesImport()

  return (
    <CollapsibleRule state={collapsibleState}>
      <CollapsibleRule.Header
        state={collapsibleState}
        onRemove={() => form.setValue(name, undefined)}
      >
        <CollapsibleRule.Title state={collapsibleState} count={items.length}>
          <CategoriesSelector.Header />
        </CollapsibleRule.Title>
      </CollapsibleRule.Header>
      <CollapsibleRule.Content
        state={collapsibleState}
        focusId={`${name}.items`}
      >
        <CategoriesSelector>
          <CollapsibleRule.Actions>
            <OperatorSelector name={`${name}.operator`} form={form} />
            <Inline>
              <CategoriesSelector.Download values={items} />
              <CategoriesSelector.Upload
                name={`${name}.items`}
                form={form}
                importer={importCategories}
                maxEntries={LIMITS.MAX_CATEGORIES}
              />
            </Inline>
          </CollapsibleRule.Actions>
          <CategoriesSelector.Selector
            name={`${name}.items`}
            state={form}
            loading={loading}
          />
        </CategoriesSelector>
      </CollapsibleRule.Content>
    </CollapsibleRule>
  )
}
